import React from 'react';
import Layout from '../../components/ui/Layout';

export default function ErrorPage({ message }) {
  return (
    <Layout>
      <div style={{ padding: '2rem', textAlign: 'center', color: 'red' }}>
        <h2>Error</h2>
        <p>{message || "An error occurred."}</p>
      </div>
    </Layout>
  );
}